class SuccessPopup {
    constructor() {
        this.selectors = {
            mainWrapper: "SuccessPopup",
            newsletter: {
                success: ".success-popup__newsletter",
                error: ".error-popup__newsletter",
                bannerForm: "NewsletterBanner",
                footerForm: "FooterNewsletter"
            }
        }

        this.elements = {
            mainWrapperElement: document.getElementById(this.selectors.mainWrapper),
            newsletterBannerElement: document.getElementById(this.selectors.newsletter.bannerForm),
            newsletterFooterElement: document.getElementById(this.selectors.newsletter.footerForm)
        }

        this.modifiers = {
            showed: "showed",
            open: "open"
        }
    }

    init() {
        this.checkPopupType();
    }

    checkPopupType() {
        const newsletterSuccess = this.elements.mainWrapperElement.querySelector(this.selectors.newsletter.success);
        const newsletterError = this.elements.mainWrapperElement.querySelector(this.selectors.newsletter.error);
        const isSuccesNewsletterPopup = window.location.search.includes("customer_posted=true");
        const isErrorNewsletterPopup = window.location.search.includes("contact%5Btags%5D=newsletter");

        if(isSuccesNewsletterPopup && newsletterSuccess) {
            const autocloseDelay = +newsletterSuccess.getAttribute("data-autoclose") * 1000
            newsletterSuccess.classList.add(this.modifiers.showed);
            this.openPopup();
            setTimeout(() =>{
                this.closePopup()
            }, autocloseDelay)
            

        } else if(isErrorNewsletterPopup && newsletterError) {
            const autocloseDelay = +newsletterError.getAttribute("data-autoclose") * 1000
            newsletterError.classList.add(this.modifiers.showed);
            this.openPopup();
            setTimeout(() =>{
                this.closePopup()
            }, autocloseDelay);
        }
    }

    openPopup(){
        this.elements.mainWrapperElement.setAttribute(this.modifiers.open, true);
    }

    closePopup() {
        this.elements.mainWrapperElement.removeAttribute(this.modifiers.open);
    }
}

window.successPopup = new SuccessPopup();

document.addEventListener("DOMContentLoaded", ()=>{
    window.successPopup.init();
})

